<mat-menu #analysesMenu="matMenu" [xPosition]="menuDirectionX" yPosition="above">
  <ng-template matMenuContent>
    <div *ngIf="(packagingUnitLoaded | async); else showSpinner">
      <button mat-menu-item *ngIf="!isUserValidator || hasRecyclabilityResult"
        [matMenuTriggerFor]="analysesRecyclability">{{ 'analysis.recyclabilityAnalysis.title' | transloco }}
      </button>
      <button mat-menu-item *ngIf="!isUserValidator || hasLifeCycleResult" [matMenuTriggerFor]="analysesLca"
        [disabled]="!isLcaAllowed()" [matTooltip]="!isLcaAllowed()? ('warnings.NoPremiumUserAndEnvironmentalEffects' | transloco) : ''"
        matTooltipPosition = "left">
        {{ 'analysis.lifecycleAnalysis.title' | transloco }}
      </button>
      <button mat-menu-item *ngIf="!isUserValidator" [matMenuTriggerFor]="analysesExpenseCalculation"
        [disabled]="!isCCAllowed()" [matTooltip]="!isCCAllowed()? ('warnings.OrganizationInsufficientPermissions' | transloco) : ''"
        matTooltipPosition = "left">
        {{ 'analysis.expenseCalculation.title' | transloco }}
      </button>
    </div>
  </ng-template>
</mat-menu>

<mat-menu #analysesRecyclability="matMenu" [xPosition]="menuDirectionX">
  <button [disabled]="!isAnalysisAllowed" mat-menu-item [matMenuTriggerFor]="newAnalysis" *ngIf="!isUserValidator"
    [matMenuTriggerData]="recyclabilityAnalysisMenu">{{ 'home.packagingUnitHome.createNewAnalysis' | transloco }}
  </button>
  <div *ngIf="versionsWithRecCount > 0">
    <div *ngIf="(recMenuItemsLoaded | async); else showSpinner">
      <button mat-menu-item [matMenuTriggerFor]="packagingVersions" [matMenuTriggerData]="recyclabilityAnalysisMenu">{{
        'home.packagingUnitHome.openExistingAnalysis' | transloco }}
      </button>
    </div>
  </div>
</mat-menu>

<mat-menu #analysesLca="matMenu" [xPosition]="menuDirectionX">
  <button mat-menu-item *ngIf="(!isUserValidator || hasLifeCycleResult)" [matMenuTriggerFor]="analysesCradleToGrave"
    [disabled]="!isC2GraveAllowed()" [matTooltip]="!isC2GraveAllowed()? ('warnings.NoPremiumUserAndEnvironmentalEffects' | transloco) : ''"
    matTooltipPosition = "left">
    {{ 'analysis.lifecycleAnalysis.lifecycleTypes.cradleToGrave' | transloco }}
  </button>
  <button mat-menu-item *ngIf="(!isUserValidator || hasLifeCycleResult)" [matMenuTriggerFor]="analysesCradleToGate"
    [disabled]="!isC2GateAllowed()" [matTooltip]="!isC2GateAllowed()? ('warnings.NoPremiumUserAndEnvironmentalEffects' | transloco) : ''"
    matTooltipPosition = "left">
    {{ 'analysis.lifecycleAnalysis.lifecycleTypes.cradleToGate' | transloco }}
  </button>
</mat-menu>

<mat-menu #analysesCradleToGate="matMenu" [xPosition]="menuDirectionX">
  <button [disabled]="!isAnalysisAllowed" mat-menu-item [matMenuTriggerFor]="newAnalysis" *ngIf="!isUserValidator"
    [matMenuTriggerData]="lcaCradleToGateAnalysisMenu">{{ 'home.packagingUnitHome.createNewAnalysis' | transloco }}
  </button>
  <div *ngIf="(hasCradleToGateEvaluations() || (lcaCradleToGateMenuItemsLoaded | async) === false) && versionsWithCradleToGateCount > 0">
    <div *ngIf="(lcaCradleToGateMenuItemsLoaded | async); else showSpinner">
      <button mat-menu-item [matMenuTriggerFor]="packagingVersions" [matMenuTriggerData]="lcaCradleToGateAnalysisMenu">{{
        'home.packagingUnitHome.openExistingAnalysis' | transloco }}
      </button>
    </div>
  </div>
</mat-menu>

<mat-menu #analysesCradleToGrave="matMenu" [xPosition]="menuDirectionX">
  <button [disabled]="!isAnalysisAllowed" mat-menu-item [matMenuTriggerFor]="newAnalysis" *ngIf="!isUserValidator"
    [matMenuTriggerData]="lcaAnalysisMenu">{{ 'home.packagingUnitHome.createNewAnalysis' | transloco }}
  </button>
  <div *ngIf="versionsWithLcaCount > 0">
    <div *ngIf="(lcaMenuItemsLoaded | async); else showSpinner">
      <button mat-menu-item [matMenuTriggerFor]="packagingVersions" [matMenuTriggerData]="lcaAnalysisMenu">{{
        'home.packagingUnitHome.openExistingAnalysis' | transloco }}
      </button>
    </div>
  </div>
</mat-menu>

<mat-menu #analysesExpenseCalculation="matMenu" [xPosition]="menuDirectionX">
  <button [disabled]="!isAnalysisAllowed" mat-menu-item [matMenuTriggerFor]="newAnalysis" *ngIf="!isUserValidator"
    [matMenuTriggerData]="expenseCalculationMenu">{{ 'home.packagingUnitHome.createNewAnalysis' | transloco }}
  </button>
  <div *ngIf="versionsWithExpenseCalculationCount > 0">
    <div *ngIf="(expenseMenuItemsLoaded | async); else showSpinner">
      <button mat-menu-item [matMenuTriggerFor]="packagingVersions" [matMenuTriggerData]="expenseCalculationMenu">{{
        'home.packagingUnitHome.openExistingAnalysis' | transloco }}
      </button>
    </div>
  </div>
</mat-menu>

<mat-menu #newAnalysis="matMenu" [xPosition]="menuDirectionX">
  <ng-template matMenuContent let-aliasMenuItems="menuItems" let-analysisType="analysisType" *ngIf="!isUserValidator">
    <button mat-menu-item *ngFor="let item of aliasMenuItems" (click)="createAnalysis(analysisType, item.versionId)"
      [disabled]="!isAnalysisAllowed">
      {{ 'common.text.version' | transloco }} {{ item.versionId }}
    </button>
  </ng-template>
</mat-menu>

<mat-menu #packagingVersions="matMenu" [xPosition]="menuDirectionX">
  <ng-template matMenuContent let-aliasMenuItems="menuItems.filter(x=> x.analysisVersions.length > 0)">
    <button mat-menu-item *ngFor="let item of aliasMenuItems" [matMenuTriggerFor]="analysisVersions"
      [matMenuTriggerData]="item">
      {{ 'common.text.version' | transloco }} {{ item.versionId }}
    </button>
  </ng-template>
</mat-menu>

<mat-menu #analysisVersions="matMenu" [xPosition]="menuDirectionX">
  <ng-template matMenuContent let-aliasMenuItems="analysisVersions" let-analysisType="analysisType"
    let-version="versionId">
    <button mat-menu-item *ngFor="let item of aliasMenuItems"
      (click)="navigateToAnalysis(item.analysisVersionsId, analysisType, version)">
      {{ item.displayDate }}
    </button>
  </ng-template>
</mat-menu>

<ng-template #showSpinner>
  <div mat-menu-item>
    <mat-spinner diameter="24" color="accent" class="spinner"></mat-spinner>
    <span class="spinner-text">{{ 'common.text.searching' | transloco }}...</span>
  </div>
</ng-template>
